var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneTimeHiring({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.0417 7C13.0417 6.4247 12.5753 5.95833 12 5.95833C11.4247 5.95833 10.9583 6.4247 10.9583 7V12C10.9583 12.2763 11.0681 12.5412 11.2634 12.7366L14.799 16.2721C15.2058 16.6789 15.8653 16.6789 16.2721 16.2721C16.6789 15.8653 16.6789 15.2058 16.2721 14.799L13.0417 11.5685V7Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneTimeHiring);
export default __webpack_public_path__ + "static/media/one-time-hiring.790eaee3ff648b43ba8ca17c70476041.svg";
export { ForwardRef as ReactComponent };